import {
  contentSetting,
  image,
  title,
  buttonThemeUuid,
  featuredProducts,
  titleTextColor,
  buttonText,
} from './constant';

const contentSettingFields = [
  [contentSetting, image],
  [contentSetting, title],
];

const contentSettingResetFields = [[contentSetting, title]];
const contentSettingResponsiveResetFields = [[contentSetting, image]];

const buttonStyleFields = [
  [buttonText, buttonThemeUuid],
  [buttonText, buttonText],
];

const buttonStyleResetFields = [[buttonText, buttonText]];
const buttonStyleResponsiveResetFields = [[buttonText, buttonThemeUuid]];

const featuredProductsFields = [[featuredProducts, titleTextColor]];
export {
  contentSettingFields,
  buttonStyleFields,
  featuredProductsFields,
  buttonStyleResetFields,
  contentSettingResetFields,
  buttonStyleResponsiveResetFields,
  contentSettingResponsiveResetFields,
};
